import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-login-failed',
  standalone: true,
  imports: [RouterLink],
  template: `
    <div class="error-page">
      <h2>Authentication Failed</h2>
      <p>We were unable to sign you in. Please try again or contact support.</p>
      <a routerLink="/" class="btn-back">Go to Home</a>
    </div>
  `,
  styles: [`
    .error-page {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: calc(100vh - 64px);
      padding: 2rem;
      text-align: center;
    }
    h2 { font-size: 2rem; color: #b00020; margin-bottom: 1rem; }
    p  { color: #555; margin-bottom: 2rem; }
    .btn-back {
      padding: 0.6rem 1.5rem;
      background: #0078d4;
      color: #fff;
      border-radius: 4px;
      text-decoration: none;
      font-weight: 600;
    }
  `],
})
export class LoginFailedComponent {}
